import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

function TheLayout() {
  return (
    <>
      <div id='footer-bottom'>
        <div className='main_header_top'>
          <Header />
        </div>
        <div className='main_content_section'>
          <Outlet />
        </div>
        <div className='footer_section'>
          <Footer />
        </div>
      </div>
    </>
  )
}

export default TheLayout ;